export const municipalities = (
  process.env.REACT_APP_AVAILABLE_MUNICIPALITIES || ''
)
  .split(',')
  .map(String)
